export const screenSummaryTabData = [
  {
    icon: <i className="fi fi-rr-screen flex items-center"></i>,
    label: "Screen Summary",
    id: "1",
  },
  {
    icon: <i className="fi fi-sr-summary-check flex items-center"></i>,
    label: "Plan Summary",
    id: "2",
  },
];

export const AdsPlayTimeTabData = [
  {
    icon: <i className="fi fi-rr-desk"></i>,
    label: "Weekdays",
    id: "weekdays",
  },
  {
    icon: <i className="fi fi-rr-party-horn"></i>,
    label: "Saturday",
    id: "saturdays",
  },
  {
    icon: <i className="fi fi-br-sun"></i>,
    label: "Sunday",
    id: "sundays",
  },
];

export const playCreativeTime = [
  {
    icon: <i className="fi fi-br-brightness text-[#EAB308] flex items-center justify-center"></i>,
    label: "Day Time Creative",
    id: "1",
  },
  {
    icon: <i className="fi fi-sr-moon-stars text-[#8B5CF6] flex items-center justify-center"></i>,
    label: "Night Time Creative",
    id: "2",
  },
];

export const screenSummaryData = {
  India: {
    Haryana: {
      Gurgaon: {
        Malls: {
          "International Brands Floor": {
            "6666d84ebb091c97e0922972": "CyberHubTwin_(3x2_1280x768)",
            "6666d84ebb091c97e0922979": "Vishal Cyber City CH",
          },
          "Electronics Floor": {
            "6666d84ebb091c97e09229ae": "CyberCityBig_(10x1_6000x588)",
          },
        },
        "Road Facing": {
          "Large LED": { "6666d84ebb091c97e09229ea": "ITC_(3x2_1920x1152)" },
        },
        CBD: {
          "Building Atriums": {
            "6666d84ebb091c97e0922a26": "SPM-1_(9x8_1024x896)",
          },
          "Enterance Area": {
            "6666d84ebb091c97e0922a62": "SPM_V_(3x8_768x2048)",
          },
          "Small LED": { "6666d84ebb091c97e0922a9e": "SD-GK2 (2x1_1920x960)" },
        },
        "CBD- Corporate offices": {
          "": {
            "66b0e6aee6a4c4f2d02dc7a2": "MidCir-01_(1x1_962x962)",
            "66b0eb3ce6a4c4f2d02dc7a4": "MidCir-08_(1x1_962x962)",
            "66b0eb8ae6a4c4f2d02dc7a5": "Zeus_Testing-1",
            "66b0ebdae6a4c4f2d02dc7a6": "MidCir-04_(1x1_962x962)",
            "66b0ec29e6a4c4f2d02dc7a7": "MidCir-06_(1x1_962x962)",
            "66b0ecd2e6a4c4f2d02dc7a8": "MidCir-05_(1x1_962x962)",
            "66b0ed80e6a4c4f2d02dc7aa": "MidCir-02_(1x1_962x962)",
            "66b0ed80e6a4c4f2d02dc7ab": "MidCir-07_(1x1_962x962)",
            "66b0ed80e6a4c4f2d02dc7ac": "MidCir-03_(1x1_962x962)",
            "66ba0078331f2f2c46aa82fa": "IFC_U_Reflex (2x3_1000x1500)",
            "66ba0078331f2f2c46aa82fb": "IFC_U_Walk_Entry (2x3_1000x1500)",
            "66ba0078331f2f2c46aa82fc": "IFC_U_Social (1x2_1000x2000)",
            "66ba0078331f2f2c46aa82fd": "IFC_L_Shape (9x1_4320x480)",
            "66ba0078331f2f2c46aa82fe": "IFC_Main Entry_Front (4x1_2000x500)",
            "66ba0078331f2f2c46aa82ff": "IFC_Main_Entry_Back (7x1_2100x300)",
            "66ba0078331f2f2c46aa8300": "IFC_Escalator (8x3_2000x750)",
            "66ba0078331f2f2c46aa8301": "IFC_Sky_Walk (4x1_2000x500)",
            "66ba01f4331f2f2c46aa8303": "IFC_Stone_Wall (3x1_2100x700)",
            "66d0324040f4ca360155f0bc": "Office_1 (2x1_1920x1080)",
            "66d0324040f4ca360155f0bd": "Office_2 (2x1_1920x1080)",
          },
        },
      },
    },
    UP: {
      Noida: {
        CBD: {
          "Enterance Area": {
            "6666d84ebb091c97e0922ada": "SD-NehruPlace (4x3_2000x1500)",
          },
          "Large LED": { "6666d84ebb091c97e0922b16": "NGC_(2x1_1344x768)" },
          "Central Atrium - Ground Floor": {
            "6666d84ebb091c97e0922b53": "JaypeeGreens_(2x3.5_1536x2560)",
          },
        },
      },
    },
    "New Delhi": {
      Delhi: {
        Hostpital: {
          "Food Courts": {
            "6666d84ebb091c97e0922b90": "DGC-Pods (1x2_1080x1920)",
            "66efe12b5b2a4fc5c5d0f38c": "DGC-Pods-2 (1x2_1080x1920)",
          },
          "International Brands Floor": {
            "6666d84ebb091c97e0922bcd": "DGC-Entrance2 (2.5x1_2496x1040)",
          },
          "Building Atrium": {
            "6666d84ebb091c97e0922c0a": "DGC-Entrance1 (2x1_1920X864)",
          },
          "Electronics Floor": {
            "6666d84fbb091c97e0922c47": "DGC-CaddyHut (4x1_3120x892)",
          },
        },
        QSR: {
          "Large LED": {
            "6666d84fbb091c97e0922c84": "CP-Chemsford-(2x1_1540x768)",
          },
          "Enterance Area": {
            "6666d84fbb091c97e0922cc1": "CP-Shivaji_(2x1_1540x768)",
            "6666d850bb091c97e0922f60": "ChanakyaPuri (3x1_2428x768)",
            "6666d850bb091c97e0923091": "KhanMarket-B (2x1_1260x620)",
            "6666d850bb091c97e09230ce": "PatelChowk-A (3.5x1_2100x620)",
          },
          "Small LED": { "6666d84fbb091c97e0922cfe": "CP-ESS-(2x1_1728x768)" },
          "Building Atrium": {
            "6666d84fbb091c97e0922df2": "KhanMarket-A (3x1_1728x576)",
            "6666d850bb091c97e0923279": "Mega mall",
          },
          "International Brands Floor": {
            "6666d850bb091c97e0923054": "KaliBari_(2x1_1920x960)",
            "6666d850bb091c97e09232b6": "CP-Block-B (3.5x1_1680x480)",
            "6666d851bb091c97e09232f3": "CP-Block-A (3x1_1024x384)",
            "6666d851bb091c97e0923330": "CP-Block-F (3.5x1_1280x384)",
          },
        },
        "Road Facing": {
          "Central Atrium - Ground Floor": {
            "6666d84fbb091c97e0922d3b": "GolDakKhana (2.5x1_1280x486)",
            "6666d850bb091c97e0923017": "Panchkuiyan_(5x4_1024x768)",
          },
          "Small LED": {
            "6666d850bb091c97e0922f9d": "MaxMuller (5x4_1024x768)",
            "6666d850bb091c97e0922fda": "OfficePod-(1x2)",
            "6666d850bb091c97e0923148": "LodhiGarden (2x1_840x620)",
          },
          "Building Atrium": { "6666d850bb091c97e0923185": "Zeus_Testing-2" },
        },
        CBD: {
          "Food Courts": {
            "6666d84fbb091c97e0922d78": "UdyogBhawan_(7x4_1408x768)",
            "6666d850bb091c97e09231ff": "TeenMurti-(1x1_1440x1440)",
          },
          "International Brands Floor": {
            "6666d84fbb091c97e0922db5": "PatelChowk-B (4x3_1680x1240)",
            "6666d850bb091c97e092323c": "SouthAevnue_(2x1_1120x512)",
          },
          "Electronics Floor": {
            "6666d850bb091c97e09231c2": "KG-Marg (2x1_1562x710)",
          },
        },
        Hospital: {
          "Enterance Area": {
            "6666d84fbb091c97e0922e2f": "Safdarjung-(5x1_2940x620)",
          },
          "Food Courts": { "6666d84fbb091c97e0922e6c": "AIIMS-(2x1_1120x520)" },
          "Large LED": { "6666d850bb091c97e092310b": "INA (2x1_1970x820)" },
        },
        "Shopping Complex": {
          "Large LED": {
            "6666d84fbb091c97e0922ea9": "SanMartin-(2x1_1600x768)",
          },
          "Small LED": {
            "6666d850bb091c97e0922ee6": "RK-Ashram-(3x2_1216x768)",
          },
          "International Brands Floor": {
            "6666d851bb091c97e0923461": "JwalaHeri-TL_(2x1_1920x960)",
            "6666d851bb091c97e092349e": "JwalaHeri-2_(2x1_1920x960)",
          },
        },
        Malls: {
          "Building Atrium": {
            "6666d850bb091c97e0922f23": "AshokaHotel (3x2_1216x768)",
          },
          "International Brands Floor": {
            "6666d851bb091c97e092336d": "SD-Saket (1x2_1920x3360)",
            "6666d851bb091c97e09233aa": "SD-Emporio (2x1_1920x1080)",
            "6666d851bb091c97e09234db": "Zeus_Testing-3",
            "66939876092761700d79b4e5": "SD-GK1-A (2x1_1920x960)",
            "6693995c092761700d79b4e7": "SD-GK1-B (2x1_1920x960)",
          },
        },
        Park: {
          "International Brands Floor": {
            "6666d851bb091c97e09233e7": "ShantiNiketan_(2x1_1920x960)",
          },
        },
        Metro: {
          "International Brands Floor": {
            "6666d851bb091c97e0923424": "SD-Jasola (2x1_1920x960)",
          },
        },
      },
    },
  },
};

export const screens = [
  {
    _id: "6666d84fbb091c97e0922e6c",
    screenId: "6666d84fbb091c97e0922e6c",
    screenName: "AIIMS-(2x1_1120x520)",
    screenCode: "9tbpkA",
    images: [
      "https://www.xtreme-media.com/wp-content/uploads/2018/11/digital_billboard_mobile_before.jpg",
    ],
    location: {
      country: "India",
      state: "New Delhi",
      city: "Delhi",
    },
    lastActive:
      "Wed Sep 25 2024 12:02:27 GMT+0000 (Coordinated Universal Time)",
  },
  {
    _id: "6666d850bb091c97e0922f23",
    screenId: "6666d850bb091c97e0922f23",
    screenName: "AshokaHotel (3x2_1216x768)",
    screenCode: "1ZLgPa",
    images: [
      "https://www.xtreme-media.com/wp-content/uploads/2018/11/digital_billboard_mobile_before.jpg",
    ],
    location: {
      country: "India",
      state: "New Delhi",
      city: "Delhi",
    },
    lastActive:
      "Wed Sep 25 2024 12:02:23 GMT+0000 (Coordinated Universal Time)",
  },
  {
    _id: "6666d851bb091c97e09232f3",
    screenId: "6666d851bb091c97e09232f3",
    screenName: "CP-Block-A (3x1_1024x384)",
    screenCode: "s73zYu",
    images: [
      "https://www.xtreme-media.com/wp-content/uploads/2018/11/digital_billboard_mobile_before.jpg",
    ],
    location: {
      country: "India",
      state: "New Delhi",
      city: "Delhi",
    },
    lastActive:
      "Wed Sep 25 2024 12:02:32 GMT+0000 (Coordinated Universal Time)",
  },
  {
    _id: "6666d850bb091c97e09232b6",
    screenId: "6666d850bb091c97e09232b6",
    screenName: "CP-Block-B (3.5x1_1680x480)",
    screenCode: "PTA8dY",
    images: [
      "https://www.xtreme-media.com/wp-content/uploads/2018/11/digital_billboard_mobile_before.jpg",
    ],
    location: {
      country: "India",
      state: "New Delhi",
      city: "Delhi",
    },
    lastActive:
      "Wed Sep 25 2024 12:02:25 GMT+0000 (Coordinated Universal Time)",
  },
  {
    _id: "6666d851bb091c97e0923330",
    screenId: "6666d851bb091c97e0923330",
    screenName: "CP-Block-F (3.5x1_1280x384)",
    screenCode: "uFkfEq",
    images: [
      "https://www.xtreme-media.com/wp-content/uploads/2018/11/digital_billboard_mobile_before.jpg",
    ],
    location: {
      country: "India",
      state: "New Delhi",
      city: "Delhi",
    },
    lastActive:
      "Wed Sep 25 2024 12:02:31 GMT+0000 (Coordinated Universal Time)",
  },
  {
    _id: "6666d84fbb091c97e0922c84",
    screenId: "6666d84fbb091c97e0922c84",
    screenName: "CP-Chemsford-(2x1_1540x768)",
    screenCode: "4c7FBx",
    images: [
      "https://www.xtreme-media.com/wp-content/uploads/2018/11/digital_billboard_mobile_before.jpg",
    ],
    location: {
      country: "India",
      state: "New Delhi",
      city: "Delhi",
    },
    lastActive:
      "Wed Sep 25 2024 12:02:23 GMT+0000 (Coordinated Universal Time)",
  },
  {
    _id: "6666d84fbb091c97e0922cfe",
    screenId: "6666d84fbb091c97e0922cfe",
    screenName: "CP-ESS-(2x1_1728x768)",
    screenCode: "yJLJvg",
    images: [
      "https://www.xtreme-media.com/wp-content/uploads/2018/11/digital_billboard_mobile_before.jpg",
    ],
    location: {
      country: "India",
      state: "New Delhi",
      city: "Delhi",
    },
    lastActive:
      "Wed Sep 25 2024 12:02:28 GMT+0000 (Coordinated Universal Time)",
  },
  {
    _id: "6666d84fbb091c97e0922cc1",
    screenId: "6666d84fbb091c97e0922cc1",
    screenName: "CP-Shivaji_(2x1_1540x768)",
    screenCode: "QoUXHc",
    images: [
      "https://www.xtreme-media.com/wp-content/uploads/2018/11/digital_billboard_mobile_before.jpg",
    ],
    location: {
      country: "India",
      state: "New Delhi",
      city: "Delhi",
    },
    lastActive:
      "Wed Sep 25 2024 12:02:30 GMT+0000 (Coordinated Universal Time)",
  },
  {
    _id: "6666d850bb091c97e0922f60",
    screenId: "6666d850bb091c97e0922f60",
    screenName: "ChanakyaPuri (3x1_2428x768)",
    screenCode: "A7eBWt",
    images: [
      "https://www.xtreme-media.com/wp-content/uploads/2018/11/digital_billboard_mobile_before.jpg",
    ],
    location: {
      country: "India",
      state: "New Delhi",
      city: "Delhi",
    },
    lastActive:
      "Wed Sep 25 2024 12:02:23 GMT+0000 (Coordinated Universal Time)",
  },
  {
    _id: "6666d84ebb091c97e09229ae",
    screenId: "6666d84ebb091c97e09229ae",
    screenName: "CyberCityBig_(10x1_6000x588)",
    screenCode: "iBjStE",
    images: [
      "https://www.xtreme-media.com/wp-content/uploads/2018/11/digital_billboard_mobile_before.jpg",
    ],
    location: {
      country: "India",
      state: "Haryana",
      city: "Gurgaon",
    },
    lastActive:
      "Thu Sep 12 2024 12:29:19 GMT+0000 (Coordinated Universal Time)",
  },
  {
    _id: "6666d84ebb091c97e0922972",
    screenId: "6666d84ebb091c97e0922972",
    screenName: "CyberHubTwin_(3x2_1280x768)",
    screenCode: "nhbQ9h",
    images: [
      "https://www.xtreme-media.com/wp-content/uploads/2018/11/digital_billboard_mobile_before.jpg",
    ],
    location: {
      country: "India",
      state: "Haryana",
      city: "Gurgaon",
    },
    lastActive:
      "Thu Sep 12 2024 11:24:23 GMT+0000 (Coordinated Universal Time)",
  },
  {
    _id: "6666d84fbb091c97e0922c47",
    screenId: "6666d84fbb091c97e0922c47",
    screenName: "DGC-CaddyHut (4x1_3120x892)",
    screenCode: "AVVJqN",
    images: [
      "https://www.xtreme-media.com/wp-content/uploads/2018/11/digital_billboard_mobile_before.jpg",
    ],
    location: {
      country: "India",
      state: "New Delhi",
      city: "Delhi",
    },
    lastActive:
      "Wed Sep 25 2024 12:02:17 GMT+0000 (Coordinated Universal Time)",
  },
  {
    _id: "6666d84ebb091c97e0922c0a",
    screenId: "6666d84ebb091c97e0922c0a",
    screenName: "DGC-Entrance1 (2x1_1920X864)",
    screenCode: "yTdH6X",
    images: [
      "https://www.xtreme-media.com/wp-content/uploads/2018/11/digital_billboard_mobile_before.jpg",
    ],
    location: {
      country: "India",
      state: "New Delhi",
      city: "Delhi",
    },
    lastActive:
      "Wed Sep 25 2024 11:56:25 GMT+0000 (Coordinated Universal Time)",
  },
  {
    _id: "6666d84ebb091c97e0922bcd",
    screenId: "6666d84ebb091c97e0922bcd",
    screenName: "DGC-Entrance2 (2.5x1_2496x1040)",
    screenCode: "Wgzp9F",
    images: [
      "https://www.xtreme-media.com/wp-content/uploads/2018/11/digital_billboard_mobile_before.jpg",
    ],
    location: {
      country: "India",
      state: "New Delhi",
      city: "Delhi",
    },
    lastActive:
      "Wed Sep 25 2024 12:02:29 GMT+0000 (Coordinated Universal Time)",
  },
  {
    _id: "6666d84ebb091c97e0922b90",
    screenId: "6666d84ebb091c97e0922b90",
    screenName: "DGC-Pods (1x2_1080x1920)",
    screenCode: "QHdrYr",
    images: [
      "https://www.xtreme-media.com/wp-content/uploads/2018/11/digital_billboard_mobile_before.jpg",
    ],
    location: {
      country: "India",
      state: "New Delhi",
      city: "Delhi",
    },
    lastActive:
      "Wed Sep 25 2024 12:02:30 GMT+0000 (Coordinated Universal Time)",
  },
  {
    _id: "66efe12b5b2a4fc5c5d0f38c",
    screenId: "66efe12b5b2a4fc5c5d0f38c",
    screenName: "DGC-Pods-2 (1x2_1080x1920)",
    screenCode: "iMMD4A",
    images: [
      "https://www.xtreme-media.com/wp-content/uploads/2018/11/digital_billboard_mobile_before.jpg",
    ],
    location: {
      country: "India",
      state: "New Delhi",
      city: "Delhi",
    },
    lastActive:
      "Wed Sep 25 2024 12:02:22 GMT+0000 (Coordinated Universal Time)",
  },
  {
    _id: "6666d84fbb091c97e0922d3b",
    screenId: "6666d84fbb091c97e0922d3b",
    screenName: "GolDakKhana (2.5x1_1280x486)",
    screenCode: "30gbSB",
    images: [
      "https://www.xtreme-media.com/wp-content/uploads/2018/11/digital_billboard_mobile_before.jpg",
    ],
    location: {
      country: "India",
      state: "New Delhi",
      city: "Delhi",
    },
    lastActive:
      "Wed Sep 25 2024 12:02:31 GMT+0000 (Coordinated Universal Time)",
  },
  {
    _id: "66ba0078331f2f2c46aa8300",
    screenId: "66ba0078331f2f2c46aa8300",
    screenName: "IFC_Escalator (8x3_2000x750)",
    images: [
      "https://proohimage.s3.ap-south-1.amazonaws.com/Screen+images/NGC+T++point+1+Dummy.jpg",
      "https://proohimage.s3.ap-south-1.amazonaws.com/Screen+images/NGC+T++point+1+Dummy.jpg",
      "https://proohimage.s3.ap-south-1.amazonaws.com/Screen+images/NGC+T++point+1+Dummy.jpg",
      "https://proohimage.s3.ap-south-1.amazonaws.com/Screen+images/NGC+T++point+1+Dummy.jpg",
    ],
    screenCode: "cqu9RY",
    location: {
      country: "India",
      state: "Haryana",
      city: "Gurgaon",
    },
    lastActive:
      "Wed Sep 25 2024 12:02:25 GMT+0000 (Coordinated Universal Time)",
  },
  {
    _id: "66ba0078331f2f2c46aa82fd",
    screenId: "66ba0078331f2f2c46aa82fd",
    screenName: "IFC_L_Shape (9x1_4320x480)",
    images: [
      "https://proohimage.s3.ap-south-1.amazonaws.com/Screen+images/NGC+T++point+1+Dummy.jpg",
      "https://proohimage.s3.ap-south-1.amazonaws.com/Screen+images/NGC+T++point+1+Dummy.jpg",
      "https://proohimage.s3.ap-south-1.amazonaws.com/Screen+images/NGC+T++point+1+Dummy.jpg",
      "https://proohimage.s3.ap-south-1.amazonaws.com/Screen+images/NGC+T++point+1+Dummy.jpg",
    ],
    screenCode: "3qmxSd",
    location: {
      country: "India",
      state: "Haryana",
      city: "Gurgaon",
    },
    lastActive:
      "Wed Sep 25 2024 12:02:25 GMT+0000 (Coordinated Universal Time)",
  },
  {
    _id: "66ba0078331f2f2c46aa82fe",
    screenId: "66ba0078331f2f2c46aa82fe",
    screenName: "IFC_Main Entry_Front (4x1_2000x500)",
    images: [
      "https://proohimage.s3.ap-south-1.amazonaws.com/Screen+images/NGC+T++point+1+Dummy.jpg",
      "https://proohimage.s3.ap-south-1.amazonaws.com/Screen+images/NGC+T++point+1+Dummy.jpg",
      "https://proohimage.s3.ap-south-1.amazonaws.com/Screen+images/NGC+T++point+1+Dummy.jpg",
      "https://proohimage.s3.ap-south-1.amazonaws.com/Screen+images/NGC+T++point+1+Dummy.jpg",
    ],
    screenCode: "wS1CKZ",
    location: {
      country: "India",
      state: "Haryana",
      city: "Gurgaon",
    },
    lastActive:
      "Wed Sep 25 2024 12:02:25 GMT+0000 (Coordinated Universal Time)",
  },
  {
    _id: "66ba0078331f2f2c46aa82ff",
    screenId: "66ba0078331f2f2c46aa82ff",
    screenName: "IFC_Main_Entry_Back (7x1_2100x300)",
    images: [
      "https://proohimage.s3.ap-south-1.amazonaws.com/Screen+images/NGC+T++point+1+Dummy.jpg",
      "https://proohimage.s3.ap-south-1.amazonaws.com/Screen+images/NGC+T++point+1+Dummy.jpg",
      "https://proohimage.s3.ap-south-1.amazonaws.com/Screen+images/NGC+T++point+1+Dummy.jpg",
      "https://proohimage.s3.ap-south-1.amazonaws.com/Screen+images/NGC+T++point+1+Dummy.jpg",
    ],
    screenCode: "7YrB6V",
    location: {
      country: "India",
      state: "Haryana",
      city: "Gurgaon",
    },
    lastActive:
      "Wed Sep 25 2024 12:02:25 GMT+0000 (Coordinated Universal Time)",
  },
  {
    _id: "66ba0078331f2f2c46aa8301",
    screenId: "66ba0078331f2f2c46aa8301",
    screenName: "IFC_Sky_Walk (4x1_2000x500)",
    images: [
      "https://proohimage.s3.ap-south-1.amazonaws.com/Screen+images/NGC+T++point+1+Dummy.jpg",
      "https://proohimage.s3.ap-south-1.amazonaws.com/Screen+images/NGC+T++point+1+Dummy.jpg",
      "https://proohimage.s3.ap-south-1.amazonaws.com/Screen+images/NGC+T++point+1+Dummy.jpg",
      "https://proohimage.s3.ap-south-1.amazonaws.com/Screen+images/NGC+T++point+1+Dummy.jpg",
    ],
    screenCode: "tF9NDe",
    location: {
      country: "India",
      state: "Haryana",
      city: "Gurgaon",
    },
    lastActive:
      "Wed Sep 25 2024 12:02:25 GMT+0000 (Coordinated Universal Time)",
  },
  {
    _id: "66ba01f4331f2f2c46aa8303",
    screenId: "66ba01f4331f2f2c46aa8303",
    screenName: "IFC_Stone_Wall (3x1_2100x700)",
    images: [
      "https://proohimage.s3.ap-south-1.amazonaws.com/Screen+images/NGC+T++point+1+Dummy.jpg",
      "https://proohimage.s3.ap-south-1.amazonaws.com/Screen+images/NGC+T++point+1+Dummy.jpg",
      "https://proohimage.s3.ap-south-1.amazonaws.com/Screen+images/NGC+T++point+1+Dummy.jpg",
      "https://proohimage.s3.ap-south-1.amazonaws.com/Screen+images/NGC+T++point+1+Dummy.jpg",
    ],
    screenCode: "U8aNVG",
    location: {
      country: "India",
      state: "Haryana",
      city: "Gurgaon",
    },
    lastActive:
      "Wed Sep 25 2024 12:02:25 GMT+0000 (Coordinated Universal Time)",
  },
  {
    _id: "66ba0078331f2f2c46aa82fa",
    screenId: "66ba0078331f2f2c46aa82fa",
    screenName: "IFC_U_Reflex (2x3_1000x1500)",
    screenCode: "6CwaKg",
    images: [
      "https://proohimage.s3.ap-south-1.amazonaws.com/Screen+images/NGC+T++point+1+Dummy.jpg",
      "https://proohimage.s3.ap-south-1.amazonaws.com/Screen+images/NGC+T++point+1+Dummy.jpg",
      "https://proohimage.s3.ap-south-1.amazonaws.com/Screen+images/NGC+T++point+1+Dummy.jpg",
      "https://proohimage.s3.ap-south-1.amazonaws.com/Screen+images/NGC+T++point+1+Dummy.jpg",
    ],
    location: {
      country: "India",
      state: "Haryana",
      city: "Gurgaon",
    },
    lastActive:
      "Wed Sep 25 2024 12:02:25 GMT+0000 (Coordinated Universal Time)",
  },
];
